var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": function ($event) {
        _vm.isOpenNewStorybook = true;
      }
    }
  }, [_vm._v("New Storybook")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": ""
    },
    on: {
      "click": function ($event) {
        _vm.isOpenCopyStorybook = true;
      }
    }
  }, [_vm._v("Copy Storybook")])], 1)]), _c('Table', {
    attrs: {
      "items": _vm.storybooks,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "name",
      "loading": _vm.loading.storybooks
    }
  }), _c('Dialog', {
    attrs: {
      "title": "Create Storybook",
      "show": _vm.isOpenNewStorybook,
      "onClose": function () {
        return _vm.isOpenNewStorybook = false;
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "32px"
    },
    attrs: {
      "model": _vm.item,
      "label-width": "190px",
      "label-position": "left",
      "size": "small",
      "width": "275px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Team Storybook Token",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.token,
      callback: function ($$v) {
        _vm.$set(_vm.item, "token", $$v);
      },
      expression: "item.token"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Storybook URL",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.storybook_url,
      callback: function ($$v) {
        _vm.$set(_vm.item, "storybook_url", $$v);
      },
      expression: "item.storybook_url"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSync(_vm.item);
      }
    }
  }, [_vm._v("Sync")])], 1)], 1)], 1), _c('Dialog', {
    attrs: {
      "title": "Copy Storybook",
      "show": _vm.isOpenCopyStorybook,
      "onClose": function () {
        return _vm.isOpenCopyStorybook = false;
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "32px"
    },
    attrs: {
      "model": _vm.item,
      "label-width": "190px",
      "label-position": "left",
      "size": "small",
      "width": "275px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "From team id",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.copyDialogData.fromTeamId,
      callback: function ($$v) {
        _vm.$set(_vm.copyDialogData, "fromTeamId", $$v);
      },
      expression: "copyDialogData.fromTeamId"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "To team id",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.copyDialogData.toTeamId,
      callback: function ($$v) {
        _vm.$set(_vm.copyDialogData, "toTeamId", $$v);
      },
      expression: "copyDialogData.toTeamId"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleCopy(_vm.item);
      }
    }
  }, [_vm._v("Copy")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }